var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-change"},[_c('header-mobile-page',{attrs:{"label":"Change Password"}}),_c('password-change')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }